import { DateRestrictionTypes } from "../../interfaces/date-restriction-type.enum";
import { IFilterFirmCount, IRestriction } from "../../interfaces/filter.interface";
import { IPresetReduced } from "../../interfaces/presets.interface";
import { IVariable } from "../../interfaces/variable.interface";

const ActionTypes = {
  GET_FILTERS_PRESET_LIST: '[Filters] Get Filters Preset List',
  GET_FILTERS_PRESET_LIST_SUCCESS: '[Filters] Get Filters Preset List Success',
  GET_FILTERS_PRESET_LIST_FAIL: '[Filters] Get Filters Preset List Fail',

  GET_FILTER_PRESET: '[Filters] Get Filter Preset',
  GET_FILTER_PRESET_SUCCESS: '[Filters] Get Filter Preset Success',
  GET_FILTER_PRESET_FAIL: '[Filters] Get Filter Preset Fail',

  GET_FIRMIDLIST_PRESET_LIST: '[Filters] Get FirmIdList Preset List',
  GET_FIRMIDLIST_PRESET_LIST_SUCCESS: '[Filters] Get FirmIdList Preset List Success',
  GET_FIRMIDLIST_PRESET_LIST_FAIL: '[Filters] Get FirmIdList Preset List Fail',

  GET_FIRMIDLIST_PRESET: '[Filters] Get FirmIdList Preset',
  GET_FIRMIDLIST_PRESET_SUCCESS: '[Filters] Get FirmIdList Preset Success',
  GET_FIRMIDLIST_PRESET_FAIL: '[Filters] Get FirmIdList Preset Fail',

  SAVE_FILTER_PRESET: '[Filters] Save Filter Preset',
  SAVE_FILTER_PRESET_SUCCESS: '[Filters] Save Filter Preset Success',
  SAVE_FILTER_PRESET_FAIL: '[Filters] Save Filter Preset Fail',

  GET_FILTER_COUNTS: '[Filters] Get Filter Counts',
  GET_FILTER_COUNTS_SUCCESS_SAMPLE: '[Filters] Get Filter Counts Success Sample',
  GET_FILTER_COUNTS_SUCCESS: '[Filters] Get Filter Counts Success',
  GET_FILTER_COUNTS_FAIL: '[Filters] Get Filter Counts Fail',
  GET_FILTER_COUNTS_STREAM: '[Filters] Get Filter Counts Stream',

  SET_CURRENT_FILTER_COUNT_RESULT: '[Filters] Set Current Filter Count Result',

  SAVE_RESTRICTION: '[Filters] Save Restriction',
  GET_RESTRICTION: '[Filters] Get Restriction',
  REMOVE_RESTRICTION: '[Filters] Remove Restriction',

  ADD_RESTRICTION_DESCRIPTION: '[Filters] Add Restriction Description',
  
  SET_FILTER: '[Filters] Set Filter',

  CLEAR_FILTER: '[Filters] Clear Filter',
  CLEAR_FILTER_STATE: '[Filters] Clear Filter State',

  SET_CURRENT_RESTRICTION_POSITION: '[Filters] Set Current Restriction Position',
  SET_CURRENT_RESTRICTION_VARIABLE: '[Filters] Set Current Restriction Variable',
  SET_CURRENT_RESTRICTION_VALUE_TYPE: '[Filters] Set Current Restriction Value Type',
  SET_CURRENT_RESTRICTION_VALUE_ARGS: '[Filters] Set Current Restriction Value Args',
  SET_CURRENT_RESTRICTION_DATE_TYPE: '[Filters] Set Current Restriction Date Type',
  SET_CURRENT_RESTRICTION_DATE_ARGS: '[Filters] Set Current Restriction Date Args',
  SET_CURRENT_RESTRICTION_INVERT: '[Filters] Set Current Restriction Invert',
  RESET_CURRENT_RESTRICTION: '[Filters] Reset Current Restriction',

  SET_FILTER_COUNTS_SUBMITTED_HASH: '[Filters] Set Filter Counts Submitted Hash',
}

export class ClearFilterState {
  static type = ActionTypes.CLEAR_FILTER_STATE;
}

export class GetFiltersPresetList {
  static type = ActionTypes.GET_FILTERS_PRESET_LIST;
}

export class GetFiltersPresetListSuccess {
  static type = ActionTypes.GET_FILTERS_PRESET_LIST_SUCCESS;

  constructor(public payload: {'content': IPresetReduced[]}) {}
}

export class GetFiltersPresetListFail {
  static type = ActionTypes.GET_FILTERS_PRESET_LIST_FAIL;
}

export class GetFirmIdListPresetList {
  static type = ActionTypes.GET_FIRMIDLIST_PRESET_LIST;
}

export class GetFirmIdListPresetListSuccess {
  static type = ActionTypes.GET_FIRMIDLIST_PRESET_LIST_SUCCESS;

  constructor(public payload: {'content': IPresetReduced[]}) {}
}

export class GetFirmIdListPresetListFail {
  static type = ActionTypes.GET_FIRMIDLIST_PRESET_LIST_FAIL;
}

export class GetFiltersPreset {
  static type = ActionTypes.GET_FILTER_PRESET;

  constructor(public payload: string) {}
}

export class GetFiltersPresetSuccess {
  static type = ActionTypes.GET_FILTER_PRESET_SUCCESS;

  constructor(public payload: {'content': IRestriction[][]}) {}
}

export class GetFiltersPresetFail {
  static type = ActionTypes.GET_FILTER_PRESET_FAIL;
}

export class GetFirmIdListPreset {
  static type = ActionTypes.GET_FIRMIDLIST_PRESET;

  constructor(public payload: string) {}
}

export class GetFirmIdListPresetSuccess {
  static type = ActionTypes.GET_FIRMIDLIST_PRESET_SUCCESS;

  constructor(public payload: {'content': string[]}) {}
}

export class GetFirmIdListPresetFail {
  static type = ActionTypes.GET_FIRMIDLIST_PRESET_FAIL;
}

export class SaveFilterPreset {
  static type = ActionTypes.SAVE_FILTER_PRESET;

  constructor(public name: string, public filters: IRestriction[][]) {}
}

export class SaveFilterPresetSuccess {
  static type = ActionTypes.SAVE_FILTER_PRESET_SUCCESS;

  constructor(public payload: any) {}
}

export class SaveFilterPresetFail {
  static type = ActionTypes.SAVE_FILTER_PRESET_FAIL;
}

export class SaveFirmIdListPreset {
  static type = 'Save Firm Id List Preset';

  constructor(public name: string, public firmIdList: string[]) {}
}

export class SaveFirmIdListPresetSuccess {
  static type = 'Save Firm Id List Preset: Success';

  constructor(public payload: any) {}
}

export class SaveFirmIdListPresetFail {
  static type = 'Save Firm Id List Preset: Failure';
}

export class GetFilterCounts {
  static type = ActionTypes.GET_FILTER_COUNTS;

  constructor(public payload?: IRestriction[][], public setSample?: boolean) {}
}

export class GetFilterCountsSuccessWithSample {
  static type = ActionTypes.GET_FILTER_COUNTS_SUCCESS_SAMPLE;

  constructor(public payload: IFilterFirmCount) {}
}

export class GetFilterCountsSuccess {
  static type = ActionTypes.GET_FILTER_COUNTS_SUCCESS;

  constructor(public payload: IFilterFirmCount) {}
}

export class GetFilterCountsFail {
  static type = ActionTypes.GET_FILTER_COUNTS_FAIL;
  
  constructor(public payload: { status: number; message: string }) {}
}

export class GetFilterCountsStream {
  static type = ActionTypes.GET_FILTER_COUNTS_STREAM;

  constructor(public payload: string) {}
}

export class SetCurrentFilterCountResult {
  static type = ActionTypes.SET_CURRENT_FILTER_COUNT_RESULT;

  constructor(public payload: number) {}
}

export class SaveRestriction {
  static type = ActionTypes.SAVE_RESTRICTION;

  constructor(public payload?: boolean) {}
}

export class GetRestriction {
  static type = ActionTypes.GET_RESTRICTION;

  constructor(public payload: {i: number, j: number}) {}
}

export class RemoveRestriction {
  static type = ActionTypes.REMOVE_RESTRICTION;

  constructor(public payload: {i: number, j: number}) {}
}

export class SetFilter {
  static type = ActionTypes.SET_FILTER;

  constructor(public payload: any) {}
}

export class ClearFilter {
  static type = ActionTypes.CLEAR_FILTER;
}

export class SetCurrentRestrictionPosition {
  static type = ActionTypes.SET_CURRENT_RESTRICTION_POSITION;

  constructor(public payload: {i: number, j: number}) {}
}

export class SetCurrentRestrictionVariable {
  static type = ActionTypes.SET_CURRENT_RESTRICTION_VARIABLE;

  constructor(public payload: {filterVariable: IVariable, treeIndex: number, branchIndex: number}) {}
}

export class SetCurrentRestrictionValueType {
  static type = ActionTypes.SET_CURRENT_RESTRICTION_VALUE_TYPE;

  constructor(public payload: string) {}
}

export class SetCurrentRestrictionValueArgs {
  static type = ActionTypes.SET_CURRENT_RESTRICTION_VALUE_ARGS;

  constructor(public payload: any) {}
}

export class SetCurrentRestrictionDateType {
  static type = ActionTypes.SET_CURRENT_RESTRICTION_DATE_TYPE;

  constructor(public payload: DateRestrictionTypes) {}
}

export class SetCurrentRestrictionDateArgs {
  static type = ActionTypes.SET_CURRENT_RESTRICTION_DATE_ARGS;

  constructor(public payload: number[]) {}
}

export class ResetCurrentRestriction {
  static type = ActionTypes.RESET_CURRENT_RESTRICTION;
}

export class AddRestrictionDescription {
  static type = ActionTypes.ADD_RESTRICTION_DESCRIPTION;

  constructor(public payload: IRestriction) {}
}

export class SetFilterCountsSubmittedHash {
  static type = ActionTypes.SET_FILTER_COUNTS_SUBMITTED_HASH;
}

export class SetCurrentRestrictionInvert {
  static type = ActionTypes.SET_CURRENT_RESTRICTION_INVERT;

  constructor(public payload: boolean) {}
}